import { __assign } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common';
import { compKey } from './key';
var layoutClassNames = function (props) {
    var _a, _b, _c;
    return namespacedClassnames(compKey, props.className, (_a = {},
        _a["orientation-" + props.orientation] = props.orientation,
        _a["gap-" + props.gap] = props.gap,
        _a["padding-" + props.padding] = props.padding,
        _a["text-align-" + props.textAlign] = props.textAlign,
        _a), (props.orientation === 'vertical' && (_b = {},
        _b["justify-content-" + props.verticalAlignment] = props.verticalAlignment,
        _b["align-items-" + props.horizontalAlignment] = props.horizontalAlignment,
        _b)), (props.orientation === 'horizontal' && (_c = {},
        _c["justify-content-" + props.horizontalAlignment] = props.horizontalAlignment,
        _c["align-items-" + props.verticalAlignment] = props.verticalAlignment,
        _c)));
};
export var Layout = function (props) {
    return (React.createElement("div", { className: layoutClassNames(props) }, props.children));
};
export var Column = function (props) {
    return React.createElement(Layout, __assign({}, props, { orientation: 'vertical' }));
};
export var Row = function (props) {
    return React.createElement(Layout, __assign({}, props, { orientation: 'horizontal' }));
};
//# sourceMappingURL=layout.js.map